export default "__VITE_ASSET__Nds0I6SC__"